import type { SxProps, Theme } from "@mui/material/styles";
export const root: SxProps<Theme> = { display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1.5, width: "100%" };
export const contained: SxProps<Theme> = { minWidth: { xs: "auto", md: 150 }, height: 48, fontWeight: 600 };
export const finish = (mobile: boolean): SxProps<Theme> => ({ minWidth: mobile ? "auto" : 200, height: 48, fontWeight: 600 });
export const text: SxProps<Theme> = { minWidth: { xs: 90, md: 110 }, height: 46, fontWeight: 600 };
export const nav: SxProps<Theme> = { display: "inline-flex", alignItems: "center", gap: 0.75 };
export const spacer: SxProps<Theme> = { display: { xs: "none", md: "block" } };
